import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
@Component({
    selector: 'topo-link-cell',
    templateUrl: './link-cell.component.html',
    styleUrls: ['./link-cell.component.scss'],
    standalone: false
})
export class LinkCellComponent implements ICellRendererAngularComp {
  value: string;
  data: any;
  colDef: any;
  displayClass: string = 'table-row-select';

  constructor() {}

  agInit(params: any): void {
    this.colDef = params.column.colDef;
    this.value = !!params.data && this.colDef?.field ? params.data[this.colDef?.field] : params.value;
    this.data = params.data;
    this.displayClass = !!this.data ? 'table-row-select' : null;
  }

  refresh(params: any): boolean {
    const colDef = params.column.colDef;
    this.value = !!params.data ? params.data[colDef.field] : params.value;
    return true;
  }

  linkClick(): void {
    this.colDef.cellRendererParams.clicked(this.data);
  }
}
